import PropTypes from 'prop-types';
import React from 'react';
import { Box } from "@chakra-ui/react";
import bluetoothIcon from './assets/bluetooth-white.svg';
import usbIcon from './assets/usb-white.svg';
import './connection.css';
import modalBack from '../lib/assets/modalWifi.png'
import CustomModal from '../containers/custom-modal.jsx';
import { setDisconnectModal } from '../store/modals'
import {compose} from 'redux';
import {injectIntl, FormattedMessage} from 'react-intl';
import {connect} from 'react-redux';
import bindAll from 'lodash.bindall';
import connectionIconURL from './assets/matatacar-illustration.svg'

class ConnectedStep extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleMethodCancel',
            'onDisconnect'
        ]);
        this.state = {
        };
    }
    componentDidUpdate() {
    }
    componentDidMount () {
    }
    handleMethodCancel () {
        this.props.setDisconnectModal(false);
    }
    // 点击断开
    onDisconnect () {
        window.peripheral.disconnect()
        this.props.setDisconnectModal(false);
    }
    render () {
        const { mode } = this.props
        return (
            <Box>
                <CustomModal
                    id="connectModal"
                    headerImageTop={modalBack}
                    contentLabel='Nous'
                    overlayClassName="connectBoxmodalOverlay"
                    className="connectstepModal"
                    onRequestClose={this.handleMethodCancel}
                    hasHeaderLine={false}
                >
                    <div className="connectStepcontainer">
                        <Box className="activityArea">
                            <Box className="centeredRowConnent">
                                <div className="peripheralActivity">
                                    <img
                                        className="peripheralActivityIcon"
                                        src={connectionIconURL}
                                    />
                                    <img
                                        className="bluetoothConnectedIcon"
                                        src={mode === 'usb' ? usbIcon : bluetoothIcon}
                                    />
                                </div>
                            </Box>
                        </Box>
                        <Box className="bottomArea">
                            <Box className="bottomAreaItem instructions">
                                <FormattedMessage
                                    defaultMessage="Connected"
                                    description="Message indicating that a device was connected"
                                    id="gui.connection.connected"
                                />
                            </Box>
                            <div className="bottomAreaItem cornerButtons">
                                <button
                                    className="connectionButton"
                                    onClick={this.onDisconnect}
                                >
                                    <FormattedMessage
                                        defaultMessage="Disconnect"
                                        description="Button to disconnect the device"
                                        id="gui.connection.disconnect"
                                    />
                                </button>
                                <button
                                    className="connectionButton"
                                    onClick={this.handleMethodCancel}
                                >
                                    <FormattedMessage
                                        defaultMessage="Go to Editor"
                                        description="Button to return to the editor"
                                        id="gui.modal.back"
                                    />
                                </button>
                            </div>
                        </Box>
                    </div>
                </CustomModal>
            </Box>
        );
    }
}

ConnectedStep.propTypes = {
    connectModalState: PropTypes.bool,
    connectionMode: PropTypes.string
    
};

ConnectedStep.defaultProps = {
};

const mapStateToProps = state => ({
    mode: state.connectStore.mode
});

const mapDispatchToProps = dispatch => ({
    setDisconnectModal: state => dispatch(setDisconnectModal(state))
});

export default compose(
    injectIntl,
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(ConnectedStep);
